import { h } from 'preact';
import * as actions from 'store/actions';
import { accessNested } from 'utils/utils';

let staticRender;
staticRender = (props) => {
	const region = accessNested(props, 'appData.meta.region.slug');
	if (region && region !== 'sa' && region !== 'ara') {
		return <div>
			<script type="text/javascript" src="https://fast.fonts.net/jsapi/8f109710-eae7-4e74-a9ef-d58f263e36c3.js"></script>
		</div>
	}
};

let storeListeners = {};
// storeListeners[actions.TICKET_LINK_CLICKED] = (screening, theater, ev, provider) => {
//
// };

export const disabledLevels = {
	// base: true,
	// studio: true,
	// studioRegion: true,
	// title: true,
};

export {
	staticRender,
	storeListeners
};
